import { render } from "./ProBookDialog.vue?vue&type=template&id=96c631e2&scoped=true"
import script from "./ProBookDialog.vue?vue&type=script&lang=js"
export * from "./ProBookDialog.vue?vue&type=script&lang=js"

import "./ProBookDialog.vue?vue&type=style&index=0&id=96c631e2&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96c631e2"]])

export default __exports__